import { useRecoilValue } from "recoil";
import { companyManagementSearchAtom } from "../miscellaneous/companyManagementSearchAtom";

export const useCompanyManagementSearchValue = () => {
  return useRecoilValue(companyManagementSearchAtom);
};
